module.exports = __webpack_public_path__ + "img/internal-comments-zero-state.351467e0.svg";